(function () {
  "use strict";

  $(document).ready(function () {
    // Slider block ACF gallery
    $(".slider-gallery").slick({
      infinite: true,
      slidesToShow: 3,
      slidesToScroll: 1,
      variableWidth: true,
      arrows: false,
      dots: true,
      autoplay: true,
      autoplaySpeed: 2000,
      mobileFirst: true,
      responsive: [
        {
          breakpoint: 1400,
          settings: {
            arrows: true,
            dots: false,
          },
        },
      ],
    });

    // Slider block ACF blog post

    $(".slider-article").slick({
      infinite: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: false,
      dots: true,
      mobileFirst: true,
      responsive: [
        {
          breakpoint: 1200,
          settings: {
            arrows: true,
            dots: false,
          },
        },
      ],
    });

    // Slider nav tab block ACF tab contact
    $(".slider-nav-tab").slick({
      infinite: false,
      arrows: false,
      slidesToShow: 1,
      slidesToScroll: 1,
      variableWidth: true,
      mobileFirst: true,
      responsive: [
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2,
          },
        },
        {
          breakpoint: 800,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 2,
          },
        },
        {
          breakpoint: 900,
          settings: {
            slidesToShow: 4,
            slidesToScroll: 2,
          },
        },
        {
          breakpoint: 1099,
          settings: "unslick",
        },
      ],
    });

    // Slider nav-tab block ACF tab-contact
  });
})(jQuery);
